import axios from 'axios';
import { getRefreshToken, getToken, setCurrentUser, setRefreshToken, setToken } from './Sessions.jsx';
import setAxiosHeader from './AxiosHeader.jsx';
import Cookies from 'js-cookie';

const url = import.meta.env.VITE_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: url,
  maxBodyLength: Infinity,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${getToken()}`,
  },
});

axiosInstance.interceptors.request.use(
  async (config) => await setAxiosHeader(config),
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let refreshPromise = null;
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && error?.response?.data?.error !== 'Invalid credentials.') {
      if (!isRefreshing) {
        isRefreshing = true;

        refreshPromise = (async () => {
          try {
            const refreshToken = getRefreshToken();
            if (!refreshToken) throw new Error('No refresh token found');

            const response = await axios.post(`${url}/api/customer/token/refresh`, { refresh_token: refreshToken });

            await setToken(response?.data?.token);
            await setRefreshToken(response?.data?.refresh_token);
            await setCurrentUser(JSON.stringify(response?.data?.user || []));

            axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
            console.log('refreshed token');
            return response.data.token;
          } catch (refreshError) {
            Cookies.remove('_token');
            Cookies.remove('_refresh_token');
            Cookies.remove('_current_user');
            window.location.href = '/';
            throw refreshError;
          } finally {
            isRefreshing = false;
            refreshPromise = null;
          }
        })();
      }

      try {
        const newToken = await refreshPromise;
        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } catch (error) {
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
